import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { useCurrentSite } from '@ui/hooks/useCurrentSite';
import { snapQuoteService } from '@ui/services';

export const snapQuoteIndexQueryKeyPrefix = ['snap-quote', 'index'];

export const snapQuoteIndexQuery = (siteCode: string) => {
  return {
    queryKey: [...snapQuoteIndexQueryKeyPrefix, siteCode],
    queryFn: () => snapQuoteService.indexSnapQuotes(siteCode),
  };
};

export function useSnapQuoteIndex() {
  const currentSite = useCurrentSite();

  return useQuery({
    ...snapQuoteIndexQuery(currentSite.code),
    placeholderData: keepPreviousData,
  });
}

export const deleteSnapQuoteMutation = (siteCode: string) => ({
  mutationFn: (uuid: string) =>
    snapQuoteService.deleteSnapQuote(siteCode, uuid),
});

export function useDeleteSnapQuote() {
  const currentSite = useCurrentSite();
  const queryClient = useQueryClient();

  return useMutation({
    ...deleteSnapQuoteMutation(currentSite.code),
    onSuccess: async (_data, _variables, _context) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: snapQuoteIndexQuery(currentSite.code).queryKey,
        }),
      ]);
    },
  });
}
